export const theme = {
  colors: {
    primary: '#007bff',
    primaryDark: '#0056b3',
    background: '#f5f5f5',
    white: '#ffffff',
    text: '#333',
    textSecondary: '#666',
    border: '#ddd',
    brand: '#E97BA6',
  },
  shadows: {
    main: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  borderRadius: '8px',
  padding: {
    standard: '20px',
  }
}; 